import React, { useEffect, useState } from 'react';

const Inventment = () => {

    const [invesment,setinvesment] = useState([]);

    useEffect(()=>{
        fetch(`https://tracker-server-lake.vercel.app/transactions/Investment`)
        .then(res=>res.json())
        .then(d=> setinvesment(d))
    },[])

  const getInvesment =()=>{
    let val = invesment.map(v=> parseInt(v.amount) )
    let sum = 0;
    for(let i = 0; i < val.length; i++){
        sum += val[i]
    }
    return sum
  }


    // const addInvensment=(e)=>{
    // }


    return (
        <div>
            <h2 className='text-center py-6 text-2xl'>Total Invensment  $<span className='text-green-500 font-medium'>{getInvesment()}</span></h2>
           <div className="list">
            <form  className='form'>
                <input type="text" name='names' placeholder='Invensment Description' />
                <input type="text" name='price' placeholder='Price' />
                <input type="date" name='date'  />
                <button className='btn btn-sm mt-2 rounded-none btn-warning'>Add</button>
            </form>
            <div className="overflow-x-auto mt-6">
      <table className="table w-full ">
       
         <tbody className=''>
            {
                invesment.map(v=> <tr key={v._id}>
                    <td>{v.name}</td>
                    <td>{v.type}</td>
                    <td>{v.amount}</td>
                    <td>x</td>
                </tr>)
            }
         </tbody>
      </table>
    </div>
            </div>
        </div>
    );
};

export default Inventment;